import { HeaderMobile, HeaderPC } from "./loader";
import {
  LanguageSwitcherSelectors,
  SearchSelectors,
  UserContextSelectors
} from "../../redux/selectors";
import React, { useMemo, useRef } from "react";
import {
  useHeaderHeightResizeDetector,
  useHeaderWidthResizeDetector
} from "./hooks";

import { useSelector } from "react-redux";
import { IgnoreClickOutsideAttribute } from "../../constants";

const Header = () => {
  const headerRef = useRef();
  const brandId = useSelector(UserContextSelectors.brandId);
  const isPC = useSelector(UserContextSelectors.isPC);
  const lang = useSelector(LanguageSwitcherSelectors.lang);
  const searchActive = useSelector(SearchSelectors.searchActive);

  useHeaderHeightResizeDetector(headerRef);
  useHeaderWidthResizeDetector(headerRef);

  const headerProps = useMemo(
    () => ({
      lang,
      brandId,
      searchActive
    }),
    [brandId, lang, searchActive]
  );

  const customAttributes = useMemo(() => {
    return !isPC
      ? {
          [IgnoreClickOutsideAttribute]: ""
        }
      : {};
  }, [isPC]);

  return (
    <header className="uc-main-header" {...customAttributes}>
      <div className="headerWrapper" ref={headerRef}>
        {isPC ? (
          <HeaderPC {...headerProps} />
        ) : (
          <HeaderMobile {...headerProps} />
        )}
      </div>
    </header>
  );
};

export default React.memo(Header);
